import { createRoute, redirect, Link } from '@tanstack/react-router';
import { Route as rootRoute } from '../__root';
import { Layout } from '@/client/layouts/layout';
import { Markdown } from '@/client/components/ui/markdown';
import { ArrowLeft } from 'lucide-react';
import { runbookBySlug } from '@/client/content/runbook';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: 'runbook/$page',
  beforeLoad: async ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/',
      });
    }
  },
  component: RunbookPageComponent,
});

function RunbookPageComponent() {
  const { page } = Route.useParams();
  const pageData = runbookBySlug[page];

  if (!pageData) {
    return (
      <Layout>
        <div>
          <Link
            to="/runbook"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-4"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Runbook
          </Link>
          <h3 className="text-2xl font-semibold mb-4">Page Not Found</h3>
          <p className="text-muted-foreground">
            The runbook page "{page}" does not exist.
          </p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div>
        <Link
          to="/runbook"
          className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-4"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Runbook
        </Link>
        <Markdown>{pageData.content}</Markdown>
      </div>
    </Layout>
  );
}
